import { parse, format, isValid } from 'date-fns'

export default {
  formattedValidFrom () {
    const parsed = parse(this.formattedValidFrom, 'dd/MM/yyyy HH:mm', new Date())
    if (isValid(parsed)) {
      this.coupon.validFrom = format(parsed, 'yyyy-MM-dd HH:mm:ssXX')
    }
  },

  formattedValidUntil () {
    const parsed = parse(this.formattedValidUntil, 'dd/MM/yyyy HH:mm', new Date())
    if (isValid(parsed)) {
      this.coupon.validUntil = format(parsed, 'yyyy-MM-dd HH:mm:ssXX')
    }
  },

  studentSearchQuery () {
    this.searchStudents(this.studentSearchQuery)
  },
}
